module.exports = __webpack_public_path__ + "img/donante-hm-hamburguesas.27dbc923.jpg";